/* unplugin-vue-components disabled */import __unplugin_components_0 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/TreeSelect/index.vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down el-icon--right"
}, null, -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", {
  class: "form-header"
}, "其他信息", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", {
  class: "form-header"
}, "关联信息", -1);
import { listMenu } from "@/api/system/menu";
export default {
  __name: 'genInfoForm',
  props: {
    info: {
      type: Object,
      default: null
    },
    tables: {
      type: Array,
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const subColumns = ref([]);
    const menuOptions = ref({});
    const {
      proxy
    } = getCurrentInstance();

    // 表单校验
    const rules = ref({
      tplCategory: [{
        required: true,
        message: "请选择生成模板",
        trigger: "blur"
      }],
      packageName: [{
        required: true,
        message: "请输入生成包路径",
        trigger: "blur"
      }],
      moduleName: [{
        required: true,
        message: "请输入生成模块名",
        trigger: "blur"
      }],
      businessName: [{
        required: true,
        message: "请输入生成业务名",
        trigger: "blur"
      }],
      functionName: [{
        required: true,
        message: "请输入生成功能名",
        trigger: "blur"
      }]
    });
    function subSelectChange(value) {
      props.info.subTableFkName = "";
    }
    function tplSelectChange(value) {
      if (value !== "sub") {
        props.info.subTableName = "";
        props.info.subTableFkName = "";
      }
    }
    function setSubTableColumns(value) {
      for (var item in props.tables) {
        const name = props.tables[item].tableName;
        if (value === name) {
          subColumns.value = props.tables[item].columns;
          break;
        }
      }
    }
    /** 查询菜单下拉树结构 */
    function getMenuTreeselect() {
      listMenu().then(response => {
        menuOptions.value = proxy.handleTree(response.data, "menuId");
      });
    }
    watch(() => props.info.subTableName, val => {
      setSubTableColumns(val);
    });
    getMenuTreeselect();
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_question_filled = _resolveComponent("question-filled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_input = _resolveComponent("el-input");
      const _component_tree_select = __unplugin_components_0;
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createBlock(_component_el_form, {
        ref: "genInfoForm",
        model: __props.info,
        rules: _unref(rules),
        "label-width": "150px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "tplCategory"
            }, {
              label: _withCtx(() => [_createTextVNode("生成模板")]),
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: __props.info.tplCategory,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => __props.info.tplCategory = $event),
                onChange: tplSelectChange
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "单表（增删改查）",
                  value: "crud"
                }), _createVNode(_component_el_option, {
                  label: "树表（增删改查）",
                  value: "tree"
                }), _createVNode(_component_el_option, {
                  label: "主子表（增删改查）",
                  value: "sub"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "packageName"
            }, {
              label: _withCtx(() => [_createTextVNode(" 生成包路径 "), _createVNode(_component_el_tooltip, {
                content: "生成在哪个java包下，例如 com.ruoyi.system",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_question_filled)]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: __props.info.packageName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => __props.info.packageName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "moduleName"
            }, {
              label: _withCtx(() => [_createTextVNode(" 生成模块名 "), _createVNode(_component_el_tooltip, {
                content: "可理解为子系统名，例如 system",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_question_filled)]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: __props.info.moduleName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => __props.info.moduleName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "businessName"
            }, {
              label: _withCtx(() => [_createTextVNode(" 生成业务名 "), _createVNode(_component_el_tooltip, {
                content: "可理解为功能英文名，例如 user",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_question_filled)]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: __props.info.businessName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => __props.info.businessName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "functionName"
            }, {
              label: _withCtx(() => [_createTextVNode(" 生成功能名 "), _createVNode(_component_el_tooltip, {
                content: "用作类描述，例如 用户",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_question_filled)]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: __props.info.functionName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => __props.info.functionName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_createTextVNode(" 上级菜单 "), _createVNode(_component_el_tooltip, {
                content: "分配到指定菜单下，例如 系统管理",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_question_filled)]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_tree_select, {
                value: __props.info.parentMenuId,
                "onUpdate:value": _cache[5] || (_cache[5] = $event => __props.info.parentMenuId = $event),
                options: _unref(menuOptions),
                objMap: {
                  value: 'menuId',
                  label: 'menuName',
                  children: 'children'
                },
                placeholder: "请选择系统菜单"
              }, null, 8, ["value", "options"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "genType"
            }, {
              label: _withCtx(() => [_createTextVNode(" 生成代码方式 "), _createVNode(_component_el_tooltip, {
                content: "默认为zip压缩包下载，也可以自定义生成路径",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_question_filled)]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                modelValue: __props.info.genType,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => __props.info.genType = $event),
                label: "0"
              }, {
                default: _withCtx(() => [_createTextVNode("zip压缩包")]),
                _: 1
              }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
                modelValue: __props.info.genType,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => __props.info.genType = $event),
                label: "1"
              }, {
                default: _withCtx(() => [_createTextVNode("自定义路径")]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), __props.info.genType == '1' ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "genPath"
            }, {
              label: _withCtx(() => [_createTextVNode(" 自定义路径 "), _createVNode(_component_el_tooltip, {
                content: "填写磁盘绝对路径，若不填写，则生成到当前Web项目下",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_question_filled)]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: __props.info.genPath,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => __props.info.genPath = $event)
              }, {
                append: _withCtx(() => [_createVNode(_component_el_dropdown, null, {
                  dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                      onClick: _cache[8] || (_cache[8] = $event => __props.info.genPath = '/')
                    }, {
                      default: _withCtx(() => [_createTextVNode("恢复默认的生成基础路径")]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  default: _withCtx(() => [_createVNode(_component_el_button, {
                    type: "primary"
                  }, {
                    default: _withCtx(() => [_createTextVNode(" 最近路径快速选择 "), _hoisted_1]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }), __props.info.tplCategory == 'tree' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_hoisted_2, _withDirectives(_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_createTextVNode(" 树编码字段 "), _createVNode(_component_el_tooltip, {
                content: "树显示的编码字段名， 如：dept_id",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_question_filled)]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: __props.info.treeCode,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => __props.info.treeCode = $event),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.info.columns, (column, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: column.columnName + '：' + column.columnComment,
                    value: column.columnName
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_createTextVNode(" 树父编码字段 "), _createVNode(_component_el_tooltip, {
                content: "树显示的父编码字段名， 如：parent_Id",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_question_filled)]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: __props.info.treeParentCode,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => __props.info.treeParentCode = $event),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.info.columns, (column, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: column.columnName + '：' + column.columnComment,
                    value: column.columnName
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_createTextVNode(" 树名称字段 "), _createVNode(_component_el_tooltip, {
                content: "树节点的显示名称字段名， 如：dept_name",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_question_filled)]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: __props.info.treeName,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => __props.info.treeName = $event),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.info.columns, (column, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: column.columnName + '：' + column.columnComment,
                    value: column.columnName
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 512), [[_vShow, __props.info.tplCategory == 'tree']])], 64)) : _createCommentVNode("", true), __props.info.tplCategory == 'sub' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_hoisted_3, _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_createTextVNode(" 关联子表的表名 "), _createVNode(_component_el_tooltip, {
                content: "关联子表的表名， 如：sys_user",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_question_filled)]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: __props.info.subTableName,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => __props.info.subTableName = $event),
                placeholder: "请选择",
                onChange: subSelectChange
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tables, (table, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: table.tableName + '：' + table.tableComment,
                    value: table.tableName
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_createTextVNode(" 子表关联的外键名 "), _createVNode(_component_el_tooltip, {
                content: "子表关联的外键名， 如：user_id",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_question_filled)]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: __props.info.subTableFkName,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => __props.info.subTableFkName = $event),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subColumns), (column, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: column.columnName + '：' + column.columnComment,
                    value: column.columnName
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model", "rules"]);
    };
  }
};